<!-- <p-toast></p-toast> -->

<div class="est-verification-container mt-2">
    <p-card styleClass="p-card-shadow">
        <div class="card dashboardTable">
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                </ng-template>
                <ng-template pTemplate="right">
                    <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                        class="p-button-help"></button>
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                        class="p-button-info ml-3"></button>
                    <p-menu #menu [popup]="true" [model]="vendorEstVerificationItems"></p-menu>
                </ng-template>

            </p-toolbar>

            <!-- AppID	Status	Status_Ar	Remarks	FarmerName	Village	Block	District	VendorName	Program	PrograId	VendorId	EstimationDate -->

            <p-table #estVerificationTable [value]="estVerificationModel" [rows]="10" [paginator]="true"
                [globalFilterFields]="[
                'AppUserType',
                'AppID',
                'Status',
                'Status_Ar',
                'Remarks',
                'FarmerName',
                'Village',
                'Block',
                'District',
                'VendorName',
                'Program',
                'PrograId',
                'VendorId',
                'EstimationDate_filter',
                'Pending_CompletedDays',
                'Status',
                'Remarks',
                'Status_Ar', 
                'TotalArea', 
                'FinYear',
                'AssignedDate',
                'ActionDate',
                'Caste_Description',
                'ApplicantType'
                ]"
                responsiveLayout="scroll" [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" sortField="AssignedDate" [sortOrder]="1" [loading]="loading">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'MANAGE_VENDOR_MI_ESTIMATION_VERIFICATION'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="estVerificationTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>

                        </th> -->
                        <th></th>
                        <th pSortableColumn="AppUserType">{{'APP_USER_TYPE'| translate}}
                            <p-columnFilter type="text" field="AppUserType" display="menu"></p-columnFilter>
                            <p-sortIcon field="AppUserType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="AppID">{{'APP_ID'| translate}}
                            <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
                            <p-sortIcon field="AppID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ApplicantType">{{'APPLICANT_TYPE'| translate}}
                            <p-columnFilter type="text" field="ApplicantType" display="menu"></p-columnFilter>
                            <p-sortIcon field="ApplicantType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FarmerName">{{'FARMER_NAME'| translate}}
                            <p-columnFilter type="text" field="FarmerName" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmerName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Caste_Description">{{'CASTE'| translate}}
                            <p-columnFilter type="text" field="Caste_Description" display="menu"></p-columnFilter>
                            <p-sortIcon field="Caste_Description"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Village">{{'VILLAGE'| translate}}
                            <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                            <p-sortIcon field="Village"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Block">{{'BLOCK'| translate}}
                            <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                            <p-sortIcon field="Block"></p-sortIcon>
                        </th>
                        <th pSortableColumn="District">{{'DISTRICT'| translate}}
                            <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                            <p-sortIcon field="District"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TotalArea">{{'TOTAL_AREA'| translate}}
                            <p-columnFilter type="text" field="TotalArea" display="menu"></p-columnFilter>
                            <p-sortIcon field="TotalArea"></p-sortIcon>
                        </th>
                        <th pSortableColumn="VendorName">{{'VENDOR_NAME'| translate}}
                            <p-columnFilter type="text" field="VendorName" display="menu"></p-columnFilter>
                            <p-sortIcon field="VendorName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Program">{{'PROGRAM'| translate}}
                            <p-columnFilter type="text" field="Program" display="menu"></p-columnFilter>
                            <p-sortIcon field="Program"></p-sortIcon>
                        </th>
                        <th pSortableColumn="PrograId">{{'PROGRAM_ID'| translate}}
                            <p-columnFilter type="text" field="PrograId" display="menu"></p-columnFilter>
                            <p-sortIcon field="PrograId"></p-sortIcon>
                        </th>
                        <th pSortableColumn="VendorId">{{'VENDOR_ID'| translate}}
                            <p-columnFilter type="text" field="VendorId" display="menu"></p-columnFilter>
                            <p-sortIcon field="VendorId"></p-sortIcon>
                        </th>
                        <th pSortableColumn="EstimationDate">{{'ESTIMATION_DATE'| translate}}
                            <p-columnFilter type="text" field="EstimationDate_filter" display="menu"></p-columnFilter>
                            <p-sortIcon field="EstimationDate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="AssignedDate">{{'ASSIGNED_DATE'| translate}}
                            <p-columnFilter type="text" field="AssignedDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="AssignedDate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ActionDate">{{'ACTION_DATE'| translate}}
                            <p-columnFilter type="text" field="ActionDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="ActionDate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Pending_CompletedDays">{{'PENDING_COMPLETED_DAYS'| translate}}
                            <p-columnFilter type="text" field="Pending_CompletedDays" display="menu"></p-columnFilter>
                            <p-sortIcon field="Pending_CompletedDays"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Status">{{'STATUS'| translate}}
                            <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
                            <p-sortIcon field="Status"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Remarks">{{'REMARKS'| translate}}
                            <p-columnFilter type="text" field="Remarks" display="menu"></p-columnFilter>
                            <p-sortIcon field="Remarks"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Status_Ar">{{'CURRENT_STATUS'| translate}}
                            <p-columnFilter type="text" field="Status_Ar" display="menu"></p-columnFilter>
                            <p-sortIcon field="Status_Ar"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                            <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                            <p-sortIcon field="FinYear"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                        <!-- <td>
                            <p-tableCheckbox [value]="product"></p-tableCheckbox>
                        </td> -->
                        <td>
                            <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                class="p-button-rounded p-button-accent mr-1 btnSize"
                                (click)="miEstimationPrintForm(product.AppID, product.VendorId, product.PrograId, product.Status_Ar)"></button>
                        </td>
                        <td>{{product.AppUserType}}</td>
                        <td>{{product.AppID}}</td>
                        <td>{{product?.ApplicantType}}</td>
                        <td>{{product.FarmerName}}</td>
                        <td>{{product?.Caste_Description}}</td>
                        <td>{{product.Village}}</td>
                        <td>{{product.Block}}</td>
                        <td>{{product.District}}</td>
                        <td>{{product.TotalArea}}</td>
                        <td>{{product.VendorName}}</td>
                        <td>{{product.Program}}</td>
                        <td>{{product.PrograId}}</td>
                        <td>{{product.VendorId}}</td>
                        <td>{{product.EstimationDate | date:'medium'}}</td>
                        <td>{{product.AssignedDate | date:'medium'}}</td>
                        <td>{{product.ActionDate | date:'medium'}}</td>
                        <td>{{product.Pending_CompletedDays}}</td>
                        <td>{{product.Status}}</td>
                        <td>{{product.Remarks}}</td>
                        <td>{{product.Status_Ar}}</td>
                        <td>{{product.FinYear}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex  justify-content-between flex-column ">
                        <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{estVerificationModel ? estVerificationModel.length : 0 }} {{'VERIFICATION_APPLICATIONS_ADDED'| translate}}
                        </p>
                        <div class="flex  justify-content-between flex-column "> 
                            <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_MORE_THAN_TWO_DAYS'| translate}}</div>
                            <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_BY_ONE_DAY'| translate}}</div>
                            <div class="flex"><div style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'APROVED_ON_TIME'| translate}}</div>
                            <div class="flex"><div style="background-color:#ffb3b3 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'DELAYED_APPROVED'| translate}}</div>
                        </div>
                    </div>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>


<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>